export default "__VITE_ASSET__BvPRPoAE__"